<template>
  <div class="page-container user-list">
    <div class="page-title-container">
      <h1 class="page-title">Usuarios</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative">
          <div class="w-full w-md-auto md-flex-1">
            <div class="d-flex justify-content-between align-items-center justify-content-lg-start">
              <button type="button" class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters">
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-md-none">
                <button type="button" class="button-tooltip text-dark font-weight-bold m-0" v-b-tooltip.hover
                  title="Recargar" @click="loadData()">
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0">
            <div class="d-none d-md-flex">
              <button type="button" class="button-tooltip text-dark font-weight-bold" v-b-tooltip.hover title="Recargar"
                @click="loadData()">
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar placeholder="Buscar por usuario o nombres y apellidos" @search="onSearch"
                @input="search = $event" class="flex-1" />

              <div class="text-right mt-2 mt-md-0">
                <b-button :to="{ name: 'user-create' }" variant="none"
                  class="button button-primary ml-md-2">Agregar</b-button>
              </div>
            </div>
          </section>

          <filter-menu :show="showFilters" @hide="showFilters = false" :options="filterOptions"
            :selectedOptionFilter="filters" @setFilters="setFilters"></filter-menu>
        </div>

        <div class="w-100 d-flex flex-wrap align-items-center mt-2" v-if="showFiltersList">
          <span v-for="(val, name) in filterList" v-bind:key="name" class="filter-item">
            {{ getFilterName(name, val) }}
            <button type="button" class="text-white p-0 bg-transparent border-0 ml-2" @click="deleteFilter(name)">
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Usuario</span>
            </div>

            <div class="text-center">
              <span>Nombres y Apellidos</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.username }}</span>
                </div>

                <div class="text-center pl-5">
                  <span>{{ `${o.firstName} ${o.lastName}` }}</span>
                </div>

                <div>
                  <button type="button" class="border-0 bg-transparent" @click="o.showMobileData = !o.showMobileData">
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link :to="{
                  name: 'user-edit',
                  params: { id: o.id },
                }" class="mr-2">
                  Editar
                </router-link>

                <a href="#" @click.prevent="openChangeStatus(o)" class="mr-2">{{ getStatus(o.isActive).action }}</a>

                <a href="#" @click.prevent="openResetPassword(o)">Restablecer contraseña</a>
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Marca:</span>
                    <span v-html="o.brands"></span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Celular:</span>
                    <span>{{ o.mobile }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Perfil:</span>
                    <span>{{ getProfile(o.profile).label }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Estado:</span>
                    <span :class="`badge ${getStatus(o.status).color}`">{{
                      getStatus(o.status).label
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Nombres y Apellidos</th>
              <th>
                Marca
              </th>
              <th>Celular</th>
              <th>Perfil</th>
              <th>Estado</th>
              <th class="pr-md-4">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="pl-3">{{ o.username }}</td>
              <td>{{ `${o.firstName} ${o.lastName}` }}</td>
              <td v-html="o.brands" class="brand-list"></td>
              <td class="text-center">{{ o.mobile }}</td>
              <td class="text-center">{{ getProfile(o.profile).label }}</td>
              <td class="text-center">
                <span :class="`badge ${getStatus(o.isActive).color}`">{{
                  getStatus(o.isActive).label
                }}</span>
              </td>
              <td class="text-center d_option pr-md-3">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem @click="
                      $router.push({
                        name: 'user-edit',
                        params: { id: o.id },
                      })
                      " text="Editar" />
                    <DropdownItem :text="getStatus(o.isActive).action" @click="openChangeStatus(o)" />

                    <DropdownItem text="Restablecer contraseña" @click="openResetPassword(o)" />

                    <DropdownItem text="Eliminar" @click="openDelete(o)" />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination :total="total" :page="page" :page-size="pageSize" :pages="pages" :changePage="changePage"
          :changePageSize="changePageSize" />
      </div>
    </div>

    <ConfirmationModal :show="confirmationModal.show" @hide="closeConfirmationModal" :data="confirmationModal"
      @confirm="confirmModal" />
  </div>
</template>

<script>
import { UsersService } from "@/core/services";
import { Constants as LocalConstants } from '@/core/utils'

import {
  Alert,
  Constants,
  Util,
  PaginationMixin,
  DropdownTable,
  DropdownItem,
  SearchBar,
  FilterMenu,
  FilterMixin,
  ConfirmationModal,
  ConfirmationModalMixin
} from "wize-admin";
import { mapGetters } from 'vuex';

export default {
  components: {
    SearchBar,
    FilterMenu,
    DropdownTable,
    DropdownItem,
    ConfirmationModal
  },
  mixins: [PaginationMixin, FilterMixin, ConfirmationModalMixin],
  data() {
    return {
      webUrl: process.env.VUE_APP_WEB_URL,
      list: [],
      tooltipType: null,
      filterOptions: [
        {
          label: "Estado",
          key: "isActive",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.UsersStatus.ACTIVE,
            LocalConstants.UsersStatus.INACTIVE
          ],
        },
        {
          label: "Perfil",
          key: "profile",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.ProfileTypes.SUPER_ADMINISTRATOR,
            LocalConstants.ProfileTypes.ADMINISTRATOR,
            LocalConstants.ProfileTypes.SUPERVISOR
          ],
        }
      ],
    };
  },
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        let filters = { ...this.filters }

        if (filters.profile) {
          filters.profile = filters.profile.replace("ROLE_", "")
        }

        const params = { page: this.page - 1, size: this.pageSize, sort: 'id' };
        const data = { search: this.search, ...filters };

        const response = await UsersService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        })

        this.list.forEach(item => {
          item.brands = item.businesses.map(brand => brand.tradeName).join(', ');
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (error) {
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    openDelete(o) {
      this.selectedOption = o;
      this.openConfirmationModal({ acceptText: "Borrar", action: "delete" });
    },
    getStatus(key) {
      return Util.searchValue(key, LocalConstants.UsersStatus);
    },
    getProfile(key) {
      return Util.searchValue(`ROLE_${key}`, LocalConstants.ProfileTypes);
    },
    openChangeStatus(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title: "Cambiar estado",
        description: "¿Está seguro que desea cambiar el estado?",
        acceptText: "Aceptar",
        action: "update",
      });
    },
    openResetPassword(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title: "Restablecer contraseña",
        description: "¿Está seguro que desea restablecer la contraseña de este usuario?",
        acceptText: "Aceptar",
        action: "reset-password",
      });
    },
    async resetPassword() {
      try {
        await this.$store.dispatch("app/loading", true);
        const resp = await UsersService.resetPassword(this.selectedOption.id);
        Alert.success(resp.payload.message);
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "update") this.changeStatus();
      if (this.confirmationModal.action === "reset-password") this.resetPassword();
      if (this.confirmationModal.action === "delete") this.deleteItem()
    },
    async deleteItem() {
      try {
        await this.$store.dispatch("app/loading", true);
        await UsersService.delete(
          this.selectedOption.id
        );

        Alert.success("Usuario eliminado correctamente");

        await this.loadData();
      } catch (ex) {
        console.error(ex);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async changeStatus() {
      try {
        await this.$store.dispatch("app/loading", true);
        const resp = (
          await UsersService.toggleStatus(
            this.selectedOption.id,
            !this.selectedOption.isActive
          )
        ).payload;

        const item = this.list.find((o) => {
          return o.id === resp.id;
        });
        if (item) {
          const index = this.list.indexOf(item);
          this.$set(this.list, index, resp);
        }
        Alert.success("Estado actualizado correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    }
  },
  async mounted() {
    if (this.user) {
      await this.loadData();
    }
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      business: 'app/getBusiness'
    })
  }
};
</script>

<style lang="stylus">
@import "../Styles/user-list.styl";
</style>